import { render } from "./registrar.vue?vue&type=template&id=6bdf05a2"
import script from "./registrar.vue?vue&type=script&lang=js"
export * from "./registrar.vue?vue&type=script&lang=js"

import "./registrar.vue?vue&type=style&index=0&id=6bdf05a2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__